import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email.trim(), password);
    setLoading(false);
    if (!r.ok) { toast.error(r.error || "Login failed"); return; }
    toast.success("Welcome back, Jonathan.");
    navigate("/admin", { replace: true });
  };

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  return (
    <div className="min-h-screen paper-grain flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-14 h-14 rounded-2xl bg-cvc-navy items-center justify-center">
            <Lock size={24} weight="duotone" className="text-cvc-cream" />
          </div>
          <h1 className="font-heading text-4xl text-cvc-navy mt-5">Cache Valley Consulting</h1>
          <p className="font-body text-sm uppercase tracking-[0.25em] text-cvc-red mt-1">Admin Portal</p>
        </div>

        <form onSubmit={submit} className="rounded-2xl bg-white border border-cvc-border p-8 shadow-sm" data-testid="admin-login-form">
          <div>
            <Label className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">Email</Label>
            <Input data-testid="login-email" autoComplete="username" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-cvc-cream border-cvc-border" required />
          </div>
          <div className="mt-5">
            <Label className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">Password</Label>
            <Input data-testid="login-password" autoComplete="current-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-cvc-cream border-cvc-border" required />
          </div>
          <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full mt-8 bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full py-5 h-auto">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <a href="/" className="block mt-5 text-center font-body text-xs text-cvc-ink-soft hover:text-cvc-navy">← Back to landing page</a>
        </form>
      </div>
    </div>
  );
}
